import firebase from 'firebase/app';

const config = {};

firebase.initializeApp(config);

export default firebase;